import { render, staticRenderFns } from "./previewNotice.vue?vue&type=template&id=7485dd4c&scoped=true&"
import script from "./previewNotice.vue?vue&type=script&lang=js&"
export * from "./previewNotice.vue?vue&type=script&lang=js&"
import style0 from "./previewNotice.vue?vue&type=style&index=0&id=7485dd4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7485dd4c",
  null
  
)

export default component.exports